import React from 'react';
import { StarIcon } from 'lucide-react';
const facts = [{
  value: '2 500+',
  label: 'Pedagogów z USA, Wielkiej Brytanii, Kanady i Australii'
}, {
  value: '6 + 6',
  label: 'Tomów i darmowych bonusów w zestawie'
}, {
  value: '4,9/5',
  label: 'Ocena społeczności'
}, {
  value: 'Każdy poziom',
  label: 'Od pierwszych akordów ucznia po zaawansowaną improwizację'
}];
export function SocialProofBar() {
  return <section aria-label="Dowód społeczny" className="border-y border-night-600 bg-night-900" data-id="element-304" data-mp="32jcwcejfeyc9">
      <div className="mx-auto grid max-w-shell grid-cols-2 gap-y-7 px-5 py-8 sm:px-6 sm:py-10 lg:grid-cols-4 lg:gap-x-8" data-id="element-305" data-mp="2xjs0we3gt84a">
        {facts.map((fact, index) => <div key={fact.value} className={`px-1 lg:px-6 ${index > 0 ? 'lg:border-l lg:border-night-600' : ''}`} data-id="element-306" data-mp="2tk9ch8cfqewp" data-mpi={index}>
            <p className="flex items-center gap-2 font-display text-3xl leading-none text-amber sm:text-4xl" data-id="element-307" data-mp="1i418r3l9oxjg">
              {fact.value}
              {fact.value === '4,9/5' && <StarIcon className="h-4 w-4 fill-amber text-amber" aria-hidden="true" data-id="element-308" data-mp="18o2tyw4fvjt9" />}
            </p>
            <p className="mt-3 max-w-[15rem] text-xs leading-relaxed text-cream-muted" data-id="element-309" data-mp="1dm4c9eu1jf3o">{fact.label}</p>
          </div>)}
      </div>
    </section>;
}